let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VGhB")).then(() => parcelRequire('c0Tkr'));